import {getValueBeforePercentage} from "../../utils/NumberUtils";
import Big from "big.js";

/**
 * Amount.
 */
export default class Amount {
	/**
	 * Amount in cents.
	 */
	public readonly cents: number;

	/**
	 * @param {Big | number} cents amount in cents.
	 */
	constructor(cents: number | Big) {
		if (typeof cents === "number") {
			this.cents = Number(new Big(cents).round(0, 1));
		}
		else {
			this.cents = Number(cents.round(0, 1));
		}
	}

	/**
	 * Create amount from pounds.
	 * @param pounds amount in pounds.
	 * @return created amount.
	 */
	static fromPounds(pounds: number): Amount {
		return new Amount(pounds * 100);
	}

	/**
	 * Multiple function
	 * @param {number} multiplier
	 * @returns {Amount}
	 */
	multiple(multiplier: number): Amount {
		return new Amount(this.cents * multiplier);
	}

	/**
	 * Add function
	 * @param {Amount} amount
	 * @returns {Amount}
	 */
	add(amount: Amount) {
		return new Amount(this.cents + amount.cents)
	}

	/**
	 * Subtract function
	 * @param {Amount} amount
	 * @returns {Amount}
	 */
	subtract(amount: Amount) {
		return new Amount(new Big(this.cents).minus(amount.cents))
	}

	/**
	 * Format amount to human readable string, in format €2,500.00
	 */
	format(): string {
		return `€${(this.cents / 100).toLocaleString("en", {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
	}

	/**
	 * Get value that was multiplied by given percentage.
	 * For instance. func (3000, 20) = 2500 (3000 / (1 + 0.2))
	 * @param percentage percentage value used to multiply original value.
	 */
	getValueBeforePercentage(percentage: number): Amount {
		return new Amount(getValueBeforePercentage(this.cents, percentage));
	}

	copy() {
		return new Amount(this.cents);
	}
}